import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { BrainCircuit, Moon, ShieldCheck, Zap, Heart, Check } from 'lucide-react';
const benefits = [{
  icon: BrainCircuit,
  text: 'Frenar el sobrepensamiento desde el primer día'
}, {
  icon: Moon,
  text: 'Dormir sin darle vueltas a todo'
}, {
  icon: ShieldCheck,
  text: 'Manejar tus emociones sin bloquearte'
}, {
  icon: Zap,
  text: 'Saber qué hacer en momentos de ansiedad'
}, {
  icon: Heart,
  text: 'Recuperar claridad y calma mental'
}];
const audience = ['Personas que sienten que su mente no para', 'Quienes sufren ansiedad o estrés constante', 'Personas que quieren control emocional real', 'Quienes buscan soluciones prácticas, no teoría', 'Cualquier persona sin experiencia previa'];
export function ValueProps() {
  return <AnimatedSection className="bg-navy text-white py-10 md:py-14" data-id="element-165">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-166">
        {/* What you'll achieve */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-167">
          <div className="h-1.5 bg-orange w-full" data-id="element-168"></div>
          <div className="p-6 md:p-8" data-id="element-169">
            <h3 className="font-heading font-bold text-xl md:text-2xl text-navy mb-6" data-id="element-170">
              Qué vas a lograr con este Kit
            </h3>
            <ul className="space-y-5" data-id="element-171">
              {benefits.map((item, idx) => {
              const Icon = item.icon;
              return <li key={idx} className="flex items-start gap-3" data-id="element-172">
                    <Icon size={20} className="text-orange shrink-0 mt-0.5" data-id="element-173" />
                    <span className="text-navy font-medium text-sm md:text-base" data-id="element-174">
                      {item.text}
                    </span>
                  </li>;
            })}
            </ul>
          </div>
        </div>

        {/* Who is this for */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-175">
          <div className="h-1.5 bg-orange w-full" data-id="element-176"></div>
          <div className="p-6 md:p-8" data-id="element-177">
            <h3 className="font-heading font-bold text-xl md:text-2xl text-navy mb-6" data-id="element-178">
              Para quién es este sistema
            </h3>
            <ul className="space-y-5" data-id="element-179">
              {audience.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-180">
                  <Check size={20} className="text-orange shrink-0 mt-0.5" data-id="element-181" />
                  <span className="text-navy font-medium text-sm md:text-base" data-id="element-182">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}